import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { IError } from 'src/app/models/error.model';
import { setWarningText } from 'src/app/reducers/warning-popup.reducer';
import { ClinicGroupService } from 'src/app/services/clinic-group.service';

@Component({
  selector: 'app-clinic-group-form',
  templateUrl: './clinic-group-form.component.html',
  styleUrls: ['./clinic-group-form.component.sass']
})
export class ClinicGroupFormV2Component implements OnInit {
  groupForm!: FormGroup;
  loading = false;

  constructor(
    private readonly fb: FormBuilder,
    private readonly clinicGroupService: ClinicGroupService,
    private readonly router: Router,
    private readonly store: Store<{ warningPopup: IError }>
  ) {}

  ngOnInit(): void {
    this.buildForm();
  }

  private buildForm(): void {
    this.groupForm = this.fb.group({
      name: ['', [Validators.required, Validators.minLength(2)]]
    });
  }

  cancel(): void {
    this.router.navigate(['/main/v2/clinic-groups']);
  }

  submit(): void {
    if (this.groupForm.invalid) {
      this.groupForm.markAllAsTouched();
      this.store.dispatch(setWarningText('Preencha o nome do grupo.'));
      return;
    }

    this.loading = true;
    const payload = { name: this.groupForm.value.name.trim() };

    this.clinicGroupService.createGroup(payload).subscribe({
      next: () => {
        this.loading = false;
        this.store.dispatch(setWarningText('Grupo criado com sucesso!'));
        this.router.navigateByUrl('/main/v2', { skipLocationChange: true }).then(() => {
          this.router.navigate(['main', 'v2', 'clinic-groups']);
        });
      },
      error: (error) => {
        console.error('Erro ao criar grupo de clínicas:', error);
        this.store.dispatch(setWarningText(error?.message || 'Erro ao criar grupo.', error?.status || 500));
        this.loading = false;
      }
    });
  }
}
